export enum ShopItemTag {
    Weapon, Shield, Armor, Util
}

export interface ShopItemBase {
    id: string,
    name: string,
    description: string,
    tags: ShopItemTag[],
    price: number,
    load: number,
}

export interface ShopWeapon extends ShopItemBase {
    dmg?: number,
    attack?: number,
    attack_speed?: number,
    extra?: string
}

export interface ShopArmor extends ShopItemBase {
    extra_hp: number,
}

export interface ShopShield extends ShopItemBase {
    def: number,
}

export interface ShopUtil extends ShopItemBase {
    extra: string,
}

export type ShopItem = ShopItemBase | ShopWeapon | ShopArmor | ShopShield | ShopUtil;

const armors: ShopArmor[] = [
    {
        id: 'item_armor_1',
        name: "Lekki pancerz",
        description: "",
        tags: [ShopItemTag.Armor],
        price: 10,
        load: 1,
        extra_hp: 8
    },
    {
        id: 'item_armor_2',
        name: "Średni pancerz",
        description: "",
        tags: [ShopItemTag.Armor],
        price: 10,
        load: 2,
        extra_hp: 16
    },
    {
        id: 'item_armor_3',
        name: "Ciężki pancerz",
        description: "",
        tags: [ShopItemTag.Armor],
        price: 10,
        load: 3,
        extra_hp: 24
    },
]

const weapons: ShopWeapon[] = [
    // 0
    {
        id: 'item_weapon_dagger',
        name: "nóż",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 0,
        extra: ""
    },
    {
        id: 'item_weapon_castet',
        name: "kastek",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 0,
        extra: ""
    },
    //1
    {
        id: 'item_weapon_sword',
        name: "Miecz",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 1,
        attack: 1
    },
    {
        id: 'item_weapon_small_axe',
        name: "Toporek/Obóch",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 1,
        dmg: 3
    },
    {
        id: 'item_weapon_saber',
        name: "Szabla",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 1,
        attack_speed: 1
    },
    //2
    {
        id: 'item_weapon_spear',
        name: "Włócznia",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 2,
        attack: 2
    },
    {
        id: 'item_weapon_long_sword',
        name: "Długi miecz",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 1,
        attack: 1,
        attack_speed: 1,
    },
    {
        id: 'item_weapon_axe',
        name: "Topór",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 1,
        attack: 1,
        dmg: 3,
    },
    {
        id: 'item_weapon_hammer',
        name: "Młot",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 1,
        dmg: 6,
    },
    // 3
    {
        id: 'item_weapon_great_sword',
        name: "Wielki miecz",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 1,
        attack: 1,
        dmg: 3,
        attack_speed: 1
    },
    {
        id: 'item_weapon_great_axe',
        name: "Wielki topór",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 3,
        attack: 1,
        dmg: 6,
    },
    {
        id: 'item_weapon_great_hammer',
        name: "Wielki młot",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 3,
        dmg: 9
    },
    {
        id: 'item_weapon_pik',
        name: "Pika",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 3,
        attack: 3
    },
    {
        id: 'item_weapon_halabard',
        name: "Halabarda",
        description: "",
        tags: [ShopItemTag.Weapon],
        price: 10,
        load: 3,
        attack: 2,
        dmg: 3
    },
]

const shields: ShopShield[] = [
    {
        id: 'item_shield_1',
        name: "Mała tarcza",
        description: "",
        tags: [ShopItemTag.Shield],
        price: 10,
        load: 1,
        def: 1
    }, 
    {
        id: 'item_shield_2',
        name: "Średnia tarcza",
        description: "",
        tags: [ShopItemTag.Shield],
        price: 10,
        load: 2,
        def: 2
    }, 
    {
        id: 'item_shield_3',
        name: "Ciężka tarcza",
        description: "",
        tags: [ShopItemTag.Shield],
        price: 10,
        load: 3,
        def: 3
    }, 
]

const utils: ShopUtil[] = [
    {
        id: 'item_utils_1',
        name: "Mikstura lecznicza",
        description: "",
        tags: [ShopItemTag.Util],
        price: 10,
        load: 3,
        extra: "Po wypiciu, leczy 5 punktów życia"
    },
    {
        id: 'item_utils_2',
        name: "Granat",
        description: "",
        tags: [ShopItemTag.Util],
        price: 10,
        load: 3,
        extra: "Atak obszarowy 2m, 5 obrażeń"
    },
    {
        id: 'item_utils_3',
        name: "Broń do rzucania",
        description: "",
        tags: [ShopItemTag.Util],
        price: 10,
        load: 3,
        extra: "Zestaw 5-ciu sztuk"
    },
    {
        id: 'item_utils_4',
        name: "Instrument",
        description: "",
        tags: [ShopItemTag.Util],
        price: 10,
        load: 3,
        extra: "Akcja: zapewnij wszystkim członkom drużyny skupienie do Ataku, Obrony lub tymczasowe 2 punkty życia do końca tury."
    },
    {
        id: 'item_utils_5',
        name: "Pułapka",
        description: "",
        tags: [ShopItemTag.Util],
        price: 10,
        load: 3,
        extra: "Akcja: Zastawisz płuapkę. Żeby ją wykryć wymagany jest rzut sporny na Ostrość, przy porażce zadaje 15 obrażeń i niszczy się."
    },
]

export const shopItems: ShopItem[] = [
    ...weapons,
    ...shields,
    ...armors,
    ...utils
]

export const item = (itemId: string | undefined): ShopItem | undefined => {
    if (itemId == null ) return undefined
    return shopItems.find(i => i.id === itemId)
}

export const itemLoad = (itemId: string | undefined): number => {
    const i = item(itemId)
    return i ? i.load : 0 
}
